import {Directive, Injector, Input, Optional} from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE
} from "@wm/components-base";

const DEFAULT_CLS = 'app-grid-row clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-layout-grid-row',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmLayoutGridRow]',
  providers: [
  provideAsWidgetRef(LayoutGridRowDirective)
  ],
  standalone: true,
  exportAs: 'wmLayoutGridRow'
})
export class LayoutGridRowDirective extends StylableComponent {
  static initializeProps = register('wm-layout-grid-row');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this,APPLY_STYLES_TYPE.CONTAINER);
  }
}

